import { useLocation } from 'react-router-dom';
import updateSearchParams, {
    updateSearchParam,
} from '../../core/util/updateSearchParams';
import useDefaultSorting from '../queries/useDefaultSorting';
import usePagination from './usePagination';

const useProductsListControls = (): [
    number,
    (newPageSize: number) => void,
    string,
    (newSortField: string) => void,
] => {
    const { search } = useLocation();

    const { navigateToPage } = usePagination();

    const searchParams = new URLSearchParams(search);
    const pageSize = searchParams.get('pageSize')
        ? +(searchParams.get('pageSize') as string)
        : 24;

    const sortFieldParam = searchParams.get('sortField');
    const sortOrderParam = searchParams.get('sortOrder');
    const { defaultSorting } = useDefaultSorting();
    const sortField =
        sortOrderParam && sortFieldParam
            ? `${sortFieldParam} ${sortOrderParam}`
            : `${defaultSorting[0]} ${defaultSorting[1]}`;

    const updatePageSize = (newPageSize: number) => {
        if (newPageSize !== pageSize) {
            const updatedSearch = updateSearchParam(
                search,
                'pageSize',
                `${newPageSize}`
            );

            navigateToPage(1, updatedSearch.toString());
        }
    };

    const updateSortField = (newSortField: string) => {
        if (newSortField !== sortField) {
            const updatedSearch = updateSearchParams(search, [
                {
                    name: 'sortField',
                    value: newSortField.split(' ')[0],
                },
                {
                    name: 'sortOrder',
                    value: newSortField.split(' ')[1],
                },
            ]);

            navigateToPage(1, updatedSearch.toString());
        }
    };

    return [pageSize, updatePageSize, sortField, updateSortField];
};

export default useProductsListControls;
